export enum Background {
	Phlox = "bg-fstphlox",
	Green = "bg-fstgreen",
	Onyx = "bg-fstonyx",
	LightGrey200 = "bg-fstgrey-200",
	White = "bg-white",
	Light = "bg-fstlight-100",
	LightGradient = "bg-gradient-to-b from-fstlight-100 to-white",
}
